/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `daily` - codziennie
 * * `weekly` - co tydzień
 * * `biweekly` - co 2 tygodnie
 * * `monthly` - co miesiąc
 */
export type CompanyGoalReminderFrequencyEnum = typeof CompanyGoalReminderFrequencyEnum[keyof typeof CompanyGoalReminderFrequencyEnum];


export const CompanyGoalReminderFrequencyEnum = {
  daily: 'daily',
  weekly: 'weekly',
  biweekly: 'biweekly',
  monthly: 'monthly',
} as const;
